import React from 'react';
import SubPage from '../components/site/SubPage';
import { PageSection, PageTitleBanner } from '../components/site/SubPageParts';

const IMG = '/images/site/company';

const NOT_USED_FOR = [
  'Share your personal data with any third-party vendors.',
  'Use user data in development of our AI Scammer Digital Reconnaissance countermeasure tools.',
];

const USED_FOR = [
  'Community user data is aggregated to spotlight evolving scammer threats.',
  'Innovation changes to outpace scammers’ technology advantage.',
  'Advertise and market to you, which includes sending promotional communications, targeted advertising, and presenting you with relevant offers.',
  'We also use the data to operate our business, which includes analyzing our performance, meeting our legal obligations, developing our workforce, and doing research.',
];

const Heading = ({ children }) => (
  <h2 className="mt-10 text-[24px] font-bold text-black md:text-[30px]">{children}</h2>
);

const Bullets = ({ items }) => (
  <ul className="mt-3 space-y-2">
    {items.map((item) => (
      <li key={item} className="flex gap-3 text-[15px] leading-snug text-black md:text-[17px]">
        <span aria-hidden="true" className="mt-[8px] h-1.5 w-1.5 flex-shrink-0 rounded-full bg-black" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const DataPrivacy = () => (
  <SubPage title="Data Privacy">
    <PageTitleBanner>Privacy is in our DNA</PageTitleBanner>

    <PageSection className="pt-6">
      <img
        src={`${IMG}/data-privacy-team.jpeg`}
        alt="A long row of people of many backgrounds sitting together outside an office"
        className="h-[180px] w-full object-cover small:aspect-[224/55] small:h-auto"
      />

      <p className="mt-6 text-[16px] leading-relaxed text-black md:text-[19px]">
        Privacy is a core value. Our products and features include innovative privacy technologies
        and techniques designed to minimize how much of your data we &mdash; or anyone else &mdash;
        can access. We are constantly working on new ways to keep your personal information safe.
      </p>

      <Heading>Innovation with guardrails.</Heading>
      <p className="mt-3 text-[15px] leading-relaxed text-black md:text-[17px]">
        Effective user data security standards are the marriage of technology and policies that work
        hand in hand. Data you provide through your interaction with NuVola AI&rsquo;s No / SCAM
        application is provided directly to NuVola AI and undergoes Scammer Confidence Indexing.
      </p>

      <p className="mt-5 text-[17px] text-black md:text-[19px]">We do not:</p>
      <Bullets items={NOT_USED_FOR} />

      <Heading>We do use user data:</Heading>
      <Bullets items={USED_FOR} />

      <Heading>How your data moves.</Heading>
      <div className="mt-3 space-y-4 text-[15px] leading-relaxed text-black md:text-[17px]">
        <p>
          Whenever you use a web browser to surf the internet, certain data is provided about your
          device and sent to the websites you&rsquo;re visiting &mdash; including your
          device&rsquo;s IP address, browser type and language, access times, and referring website
          addresses.
        </p>
        <p>
          That data might be logged on those websites&rsquo; or online services&rsquo; web servers.
          Which data is logged, and how that data is used, depends on the privacy practices of the
          websites you visit and the web services you use.
        </p>
      </div>

      <Heading>You need to know.</Heading>
      <p className="mt-3 text-[15px] leading-relaxed text-black md:text-[17px]">
        You provide website interaction data through your use of NuVola AI&rsquo;s No / SCAM
        application. That user data is provided directly to NuVola AI and undergoes Scammer
        Confidence Indexing.
      </p>
    </PageSection>
  </SubPage>
);

export default DataPrivacy;
